import { UndoRedoState } from 'editor/src/store/editorModules/undoRedo/types';

const pushNextStateReducer = (state: UndoRedoState) => {
  state.next = [];
};

export default pushNextStateReducer;
